import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useLoginState } from "../../hooks/useLoginState";

/**
 * ProtectedRoute component that redirects to login if user is not authenticated
 * Preserves the intended destination for redirect after login
 */
const ProtectedRoute = ({ children }) => {
    const [isLoggedIn] = useLoginState();
    const location = useLocation();

    if (!isLoggedIn) {
        // Redirect to login page and save the intended destination
        // Use relative path to work correctly with basename/alias prefix
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    //   else{
    //     return <Navigate to="/" state={{ from: location }} replace />; // Redirect to home if already logged in1
    //   }

    return children;
};

export default ProtectedRoute;
